(function () {
  'use strict';
  if (window.STMNCartTransport) return;
  var tail = Promise.resolve(), writes = 0;
  function busy() { document.dispatchEvent(new CustomEvent('stmn:cart-busy', {detail:{busy:writes > 0}})); }
  function request(url, options) {
    options = options || {};
    var write = !!options.method && options.method.toUpperCase() !== 'GET';
    if (write) { writes++; busy(); }
    var task = tail.then(function () {
      var controller = new AbortController();
      var timeout = setTimeout(function () { controller.abort(); }, 20000);
      return fetch(url, Object.assign({}, options, {signal:controller.signal, headers:Object.assign({Accept:'application/json'}, options.headers || {})}))
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) {
              var message = data.description || data.message;
              var error = new Error(typeof message === 'string' ? message : 'Non è stato possibile aggiornare il carrello. Riprova.');
              error.status = response.status;
              throw error;
            }
            return data;
          });
        }).finally(function () { clearTimeout(timeout); });
    }).finally(function () { if (write) { writes--; busy(); } });
    // A failed request must not poison the queue. The caller still receives its rejection.
    tail = task.catch(function () {});
    return task;
  }
  window.STMNCartTransport = {request:request, get busy() { return writes > 0; }};
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('#mp-cart-checkout-btn');
    if (link && (writes > 0 || link.getAttribute('aria-disabled') === 'true')) {
      event.preventDefault(); event.stopImmediatePropagation();
    }
  }, true);
})();
